/**
 * spu提示
 */
import React from 'react';
import { getText } from 'src/utils/i18n';
import { Icon } from '@alifd/next';
import HoverBalloon from 'src/common/hover-balloon';

export default function SpuTips({ hasSPU, i18n, cspuCount }) {
  if (!hasSPU) return null;

  return (
    <dl className="ma-brief-item">
      <dt className="market-action-list__dt detailed-items-key">
        {getText(i18n, 'mainAction.detailed_items', 'Product options')}{' '}
        <HoverBalloon trigger={<Icon type="help" size="xs" />}>
          {getText(
            i18n,
            'cspuTable.module_tip',
            'These are specific pre-set options or product variations that the supplier can produce. For other customization, please ask the supplier.',
          )}
        </HoverBalloon>{' '}
        :
      </dt>
      <dd className="market-action-list__dd detailed-items-value">
        <span>{cspuCount}</span>{' '}
        {getText(i18n, 'mainAction.detailed_items_total', 'available')}
        <a href="#detailed-items" className="view-spu-detail-below">
          {getText(i18n, 'mainAction.detailed_items_view', 'Select options')}↓
        </a>
      </dd>
    </dl>
  );
}
